import React from 'react';
import { Box } from '@mui/system';
import * as Styled from '../SearchAutocompleteResults.styles';
import {
  ResultRow,
  AutocompleteItemType,
} from '../SearchAutocompleteResults.types';
import { RowItem } from './RowItem';

export const RowCategory: React.FC<ResultRow> = ({
  title,
  items,
  imgVariant,
  query,
  shouldShowArrows,
  shouldShowImages,
  selectedItemId,
  shouldShowDividers,
  shouldShowIcons,
  maxItemsCount,
  maxMobileItemsCount,
  invertQueryHighlighting,
  isMobileDevice,
  onItemClick,
  onItemHover,
}) => {
  const splittedItems = React.useMemo(
    () => items?.slice(0, isMobileDevice ? maxMobileItemsCount : maxItemsCount),
    [items, isMobileDevice, maxItemsCount, maxMobileItemsCount],
  );

  return (
    <Box display="flex" flexDirection="column">
      {!!title && (
        <Styled.SectionHeader>
          <Styled.SectionTitle>{title}</Styled.SectionTitle>
        </Styled.SectionHeader>
      )}
      <Box>
        {splittedItems.map((item, index) => {
          const isSelected = item.id === selectedItemId;
          const isPreviousItemSelected =
            splittedItems[index - 1]?.id === selectedItemId;
          const isNextItemSelected =
            splittedItems[index + 1]?.id === selectedItemId;
          const shouldHideDivider =
            (index === 0 && (!title || title.length < 0)) ||
            isSelected ||
            isPreviousItemSelected;

          return (
            <React.Fragment key={index + item.value}>
              {shouldShowDividers && (
                <Styled.RowDivider shouldHide={shouldHideDivider} />
              )}
              <RowItem
                index={index}
                type={AutocompleteItemType.SUGGESTION}
                shouldShowArrows={shouldShowArrows}
                item={item}
                imgVariant={imgVariant}
                query={query}
                onClick={onItemClick}
                onItemHover={onItemHover}
                shoudShowImage={shouldShowImages}
                isSelected={isSelected}
                isPreviousItemSelected={isPreviousItemSelected}
                isNextItemSelected={isNextItemSelected}
                shouldShowDividers={shouldShowDividers}
                shouldShowIcon={shouldShowIcons}
                invertQueryHighlighting={invertQueryHighlighting}
              />
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
};
